<template>
  <section>
    <v-snackbar
      v-model="$store.state.statusSnackbar.show"
      :color="$store.state.statusSnackbar.color"
      :timeout="$store.state.statusSnackbar.timeout"
    >
      {{ $store.state.statusSnackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="$store.dispatch('statusSnackbar/close')"> Close </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<script>
  export default {};
</script>
